export function buildAuthRedirectUrl(origin = window.location.origin) {
  return String(origin || '').trim().replace(/\/+$/, '');
}
